import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { useRef } from 'react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

function AnimationHearts() {
    // On définit les références du SVG
    const containerRef = useRef(null);
    const Heart1Ref = useRef(null);
    const Heart2Ref = useRef(null);
    const Heart3Ref = useRef(null);
    const Heart4Ref = useRef(null);

    // On initialise le hook de GSAP pour React afin de gérer l'ajout et la suppression des
    // écouteurs de manière automatique
    useGSAP(() => {
        if(!containerRef || !Heart1Ref || !Heart2Ref || !Heart3Ref || !Heart4Ref) return;

        // On liste les Hearts à animer dans un tableau
        const hearts = [
            Heart1Ref.current,
            Heart2Ref.current,
            Heart3Ref.current,
            Heart4Ref.current
        ];

        // On définit les états par défaut
        gsap.set(hearts, {
            opacity: 0,
            y: containerRef.current.offsetHeight,
            scale: 0.95
        });

        // On définit l'animation ligne par ligne
        hearts.forEach((heart, i) => {
            if(!heart) return;

            // Animation de l'opacité
            gsap.to(
                heart,
                {
                    opacity: 1,
                    scale: 1.15,
                    duration: 2.5, // durée un peu variable
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: containerRef.current,
                        start: (window.innerWidth > 600) ? "top+=100 center" : "top-=100 center", // quand le SVG entre dans le viewport
                        end: "bottom center",
                        toggleActions: "play pause resume reverse",
                    },
                }
            );

            // Animation axe y
            gsap.to(
                heart,
                {
                    y: -1 * containerRef.current.offsetHeight, // en bas
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: containerRef.current,
                        start: (window.innerWidth > 600) ? "top center" : "top-=100 center", // quand le SVG entre dans le viewport
                        end: (window.innerWidth > 600) ? `+=${2000 + i * 500}` : `+=${1500 + i * 250}`,
                        toggleActions: "play pause resume reverse",
                        scrub: true,
                    },
                },
            );
        })
    }, { scope: containerRef });

    return (
        <div ref={containerRef} id={"Hearts-container"} className="row-container quiz-row-container container--full-height" aria-hidden="true">
            <div>
                <p className="quiz-paragraph">
                    Parallèlement, les usages changent.
                </p>
                <p className="quiz-paragraph">
                    On écoute, oui, mais on commente, on suit, on partage, on ne suit plus, on aime, on n’aime plus. On aime à nouveau.
                </p>
            </div>
            <svg role="img" ref={Heart1Ref} id="Heart_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 74 67">
                <title>Apparition d’un vol de petits cœurs</title>
                <path className="heart svg--primary" d="M64.07,23.5c-.17-7.45-6.35-13.36-13.8-13.19-7.21.16-13.02,5.97-13.19,13.19-.18-7.45-6.37-13.35-13.82-13.17-7.2.18-12.99,5.97-13.17,13.17,0,0-1.21,17.7,26.99,33.25,28.21-15.55,26.99-33.25,26.99-33.25"/>
            </svg>
            <svg aria-hidden="true" ref={Heart2Ref} id="Heart_2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 74 67">
                <path className="heart svg--primary" d="M64.07,23.5c-.17-7.45-6.35-13.36-13.8-13.19-7.21.16-13.02,5.97-13.19,13.19-.18-7.45-6.37-13.35-13.82-13.17-7.2.18-12.99,5.97-13.17,13.17,0,0-1.21,17.7,26.99,33.25,28.21-15.55,26.99-33.25,26.99-33.25"/>
            </svg>
            <svg aria-hidden="true" ref={Heart3Ref} id="Heart_3" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 74 67">
                <path className="heart svg--primary" d="M64.07,23.5c-.17-7.45-6.35-13.36-13.8-13.19-7.21.16-13.02,5.97-13.19,13.19-.18-7.45-6.37-13.35-13.82-13.17-7.2.18-12.99,5.97-13.17,13.17,0,0-1.21,17.7,26.99,33.25,28.21-15.55,26.99-33.25,26.99-33.25"/>
            </svg>
            <svg aria-hidden="true" ref={Heart4Ref} id="Heart_4" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 74 67">
                <path className="heart svg--primary" d="M64.07,23.5c-.17-7.45-6.35-13.36-13.8-13.19-7.21.16-13.02,5.97-13.19,13.19-.18-7.45-6.37-13.35-13.82-13.17-7.2.18-12.99,5.97-13.17,13.17,0,0-1.21,17.7,26.99,33.25,28.21-15.55,26.99-33.25,26.99-33.25"/>
            </svg>
        </div>
    );
}

export default AnimationHearts;
